/** Ford Racing Parts category names (current + legacy for id lookup). */
export const RACING_CATEGORY_NAMES = [
    'Ford Racing Parts',
    'قطع Ford Racing',
    'Performance',
    'أداء',
];

/** @deprecated Use RACING_CATEGORY_NAMES */
export const PERFORMANCE_CATEGORY_NAMES = RACING_CATEGORY_NAMES;

/** Explore Ford Racing Parts checkbox labels (UI only, not stored in DB). */
export const RACING_CHECKBOX_LABEL = {
    en: 'Explore Ford Racing Parts',
    ar: 'استكشف قطع Ford Racing',
};

export function getRacingCheckboxLabel(language = 'en') {
    return language === 'ar' ? RACING_CHECKBOX_LABEL.ar : RACING_CHECKBOX_LABEL.en;
}

export function isRacingCategoryName(name) {
    const n = (name ?? '').toString().trim();
    return RACING_CATEGORY_NAMES.includes(n);
}

/** @deprecated Use isRacingCategoryName */
export function isPerformanceCategoryName(name) {
    return isRacingCategoryName(name);
}

/** Find Ford Racing Parts category id from API list (locale-agnostic name match). */
export function findPerformanceCategoryId(categories) {
    if (!Array.isArray(categories)) return null;
    const match = categories.find((c) => c && isRacingCategoryName(c.name));
    return match ? match.id : null;
}

/** Racing category is surfaced via the Explore Ford Racing Parts filter, not main nav. */
export function shouldHideRacingCategoryFromNav(name) {
    return isRacingCategoryName(name);
}
